module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\">\r\n    <div class=\"prop-header\"><span class=\"prop-label\">Notify Settings</span></div>\r\n    <div class=\"col-md-12\">\r\n        <table id=\"propNotifyTable\"></table>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-3\">\r\n        <button type=\"button\" id=\"editNotify\" class=\"btn btn-default hvr-glow\" style=\"padding-left: 7px;\">Edit</button>\r\n    </div>\r\n</div>\r\n\r\n")
  }
  return __output;

}